
import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  horses: []
};

const slice = createSlice({
  name: 'horses',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getHorsesSuccess(state, action) {
      state.isLoading = false;
      state.horses = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  gethorsesSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

export function loadHorses() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/account/my/horses');
      // console.debug(response.data);
      dispatch(slice.actions.getHorsesSuccess(response.data.records ? response.data.records : []));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export const gethorses = state => state.horses;
